
<template>
  <div
    ref="annotationWrapper"
    :id="`annotation-wrapper-${selectedCreativeArticleCombo}`"
    class="annotation-wrapper"
    @mouseenter="onMouseEnter"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
    @click.self="onMouseClick"
  >
    <div
      class="annotations"
    >
      <div
        v-if="hasCurrentAnnotation"
        :style="getMarkerLoaction(currentAnnotation)"
        id="current-annotation"
        class="annotation transform"
      />
      <div
        v-for="(a, index) in GET_ANNOTATIONS"
        :key="`${index}${annotationKey}`"
        :style="getMarkerLoaction(a)"
        :id="`annotation-${index}`"
        :class="getAnnotationClassList(a)"
      />
    </div>
    <p
      v-show="allowAnnotations && showTooltip"
      ref="annotation-tooltip"
      id="annotation-tooltip"
      class="tooltip show"
      role="tooltip"
      x-placement="bottom"
      :style="tooltipStyle"
    >
      <span
        class="tooltip-inner"
      >
        Click to add annotation
      </span>
    </p>
  </div>
</template>
<script>
import {
  mapState, mapGetters, mapActions, mapMutations,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import _ from 'lodash';

export default {
  name: 'ContentAnnotations',
  data() {
    return {
      isMouseInFrame: false,
      tooltipStyle: {},
      showTooltip: false,
      tooltipTimeout: null,
    };
  },
  computed: {
    ...mapState('content', [
      'selectedArticleUuid',
      'selectedCreativeId',
      'allowAnnotations',
      'currentAnnotation',
      'isTriggeredAnnotation',
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ANNOTATIONS,
    ]),
    selectedCreativeArticleCombo() {
      return `${this.selectedCreativeId}-${this.selectedArticleUuid}`;
    },
    annotationKey() {
      return this.isTriggeredAnnotation ? `-${this.isTriggeredAnnotation.x}-${this.isTriggeredAnnotation.x}` : '';
    },
    hasCurrentAnnotation() {
      return (Object.keys(this.currentAnnotation).length > 0);
    },
  },
  methods: {
    ...mapMutations('content', [
      contentTypes.TOGGLE_ANNOTATIONS,
    ]),
    ...mapActions('content', [
      contentTypes.SET_CURRENT_ANNOTATION,
    ]),
    onMouseEnter() {
      this.isMouseInFrame = true;
    },
    async onMouseMove(event) {
      this.showTooltip = false;
      await this.$nextTick();
      this.$refs['annotation-tooltip'].classList.remove('fade-in');
      const { offsetX, offsetY } = event;
      this.tooltipStyle = {
        position: 'absolute',
        top: `${offsetY + 10}px`,
      };
      if (event.offsetX > event.target.clientWidth - (162 + 10)) {
        this.tooltipStyle.right = '10px';
        delete this.tooltipStyle.left;
      } else {
        this.tooltipStyle.left = `${offsetX + 10}px`;
      }
      clearTimeout(this.tooltipTimeout);
      this.tooltipTimeout = setTimeout(() => {
        if (this.isMouseInFrame) {
          this.showTooltip = true;
          this.$refs['annotation-tooltip'].classList.add('fade-in');
        }
      }, 400);
    },
    onMouseLeave() {
      this.isMouseInFrame = false;
    },
    onMouseClick(event) {
      const location = { x: event.offsetX, y: event.offsetY };
      this.SET_CURRENT_ANNOTATION(location);
    },
    getMarkerLoaction(location) {
      return `left: ${location.x - 8}px; top: ${location.y - 8}px;`;
    },
    getAnnotationClassList(annotation) {
      return _.isEqual(this.isTriggeredAnnotation, annotation) ? 'annotation selected' : 'annotation faded';
    },
  },
  watch: {
    selectedCreativeArticleCombo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.showTooltip = false;
        this.TOGGLE_ANNOTATIONS(false);
      }
    },
  },
};
</script>

<style lang="scss">
#annotation-tooltip {
  width: 162px;
  opacity: 0;
  &.fade-in {
    animation: fadeIn .3s forwards;
  }
}
@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
.annotation-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: copy;
}

.annotation {
  background: #3499ad;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  z-index: 12;
  border: 2px solid #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-shadow: 1px 1px 4px rgba(0,0,0,.6);
  box-shadow: 1px 1px 4px rgba(0,0,0,.6);
}
.annotation.transform {
  -webkit-animation: grow .3s;
  animation: grow .3s;
}
.faded {
  opacity: 0.75;
}
.selected {
  animation: selected .3s forwards;
}
@keyframes selected {
  25% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(2.4);
  }
  100% {
    transform: scale(1.6);
  }
}

@-webkit-keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
@-moz-keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
@keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
</style>
